<script>
// import HotelCard from 'components/views/my/hotels/thumbs/Hotel.svelte';
import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


// filter
import Filter from 'components/views/my/free-agents/elements/Filter.svelte'

import Table from 'components/views/my/free-agents/elements/Table.svelte'




import SvelteSeo from 'svelte-seo';


import { auth } from 'store/index.js';


import { get } from 'svelte/store';



const api_url = app_.env.API_URL;
const token = get(auth).token;



let promise = getFreeAgents();


async function getFreeAgents() {

	const url = `${api_url}coaches/irps-test`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}



let url_params = {
	position: '',
	birth_year: '',
	level: '',
	province: '',
};

let active_free_agents = [];


</script>


<style>
	

</style>



<SvelteSeo
	title='Independently Registered Players | AHG Coaches Portal'
	description='Independently Registered Players!'
/>





{#await promise}

<Loading />

{:then free_agents}

<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Spring Independently Registered Players 2022
			</p>

		</div>

	</div>
	
</section>


<!-- <Filter {url_params} {free_agents} /> -->


<section class="section">

	<div class="container">


		{#if free_agents.length === 0}

			<MsgCard msg_show={true} msg_text={'No independently registered players found!'} msg_type={'error'} msg_forever={true} />

		{:else}

			<MsgCard msg_show={true} msg_text={'These players have already registered in the NS Prospects Tier 2 division and are looking for a team. Feel free to reach out to them if you think they may be a fit for your team. If you come to an agreement to take an IRP player for your roster, please contact the AHG office immediately so AHG can remove the player from this list and place them on your team.'} msg_type={'error'} msg_forever={true} />

			<MsgCard msg_show={true} msg_text={'Click on an independently registered player to get contact information.'} msg_type={'error'} msg_forever={true} />

			<Filter bind:url_params {free_agents} />


			<!-- <div class="columns is-variable is-centered">


				<div class="column is-10-desktop is-12-touch"> -->

					<Table {url_params} {free_agents} />

				<!-- </div>

			</div> -->

		{/if}


	</div>

</section>

{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}




 